const isJsonObject = (storageObj: JsonType): storageObj is JsonObject =>
    !!storageObj && typeof storageObj === 'object' && !Array.isArray(storageObj);

export { isJsonObject };
